module.exports = __webpack_public_path__ + "static/step-2-img-24209c4bd51fecc4a22c1728b3c4acbe.png";